module.exports = __webpack_public_path__ + "img/pulic_1.f32114c9.png";